import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';
import {HistoricalWellsService} from '../../historical-wells/historical-wells.service';
import {Subscription} from 'rxjs';
import {Helper} from '../../../../shared/helpers/helper';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import {TreatmentService} from '../../../../shared/services/treatment.service';
import {UserAuthService} from '../../../../shared/services/user-auth.service';
import {User} from '../../../../shared/models/user.model';
import {HistoricalWellsTableComponent} from './historical-wells-table.component';
import {CPATTERN} from '../../../../shared/helpers/app.constants';

@Component({
  selector: 'app-companies-historical-wells-form',
  templateUrl: './historical-wells-form.component.html',
  styleUrls: ['./historical-wells.component.scss']
})
export class CompaniesHistoricalWellsFormComponent implements OnInit, OnDestroy {

  @ViewChild(HistoricalWellsTableComponent) wellTable: HistoricalWellsTableComponent;
  subscriptions: Subscription[] = [];
  cvalidate = CPATTERN;
  countWells: number = 0;
  wellItems: any;

  user: User;
  listSelectWells: any[] = [];
  originListWells: any[] = [];
  listContries: any[] = [];
  listStates: any[] = [];
  listConties: any[] = [];
  listServiceCompanies: any[] = [];
  listOperatorCompanies: any[] = [];
  // Form
  form: FormGroup;
  country: AbstractControl;
  state: AbstractControl;
  county: AbstractControl;
  serviceCompanyName: AbstractControl;
  operatorCompanyName: AbstractControl;
  prospect: AbstractControl;


  @Input()
  set listWells(list: any) {
    if (list) {
      this.originListWells = list;
      this.listSelectWells = list;
    }
  }

  @Input() maxWells: number;
  @Input() countItemWells: number;

  constructor(private dialogRef: NbDialogRef<any>,
              private userAuthService: UserAuthService,
              private historicalWellsService: HistoricalWellsService,
              private treatmentService: TreatmentService) {
    this.createForm();
    this.user = this.userAuthService.getUserInfo();
  }

  ngOnInit() {
    this.getCountries();
    this.getStates();
    this.getCounties();
    if (this.user && this.user.companyType !== 'Service') {
      this.getServiceCompanies();
    }
    if (this.user && this.user.companyType !== 'Operator') {
      this.getOperatorCompanies();
    }
  }

  createForm() {
    this.form = new FormGroup({
      country: new FormControl(''),
      state: new FormControl(''),
      county: new FormControl(''),
      serviceCompanyName: new FormControl(''),
      operatorCompanyName: new FormControl(''),
      prospect: new FormControl('', Validators.compose([Validators.minLength(2), Validators.maxLength(50), Validators.pattern(this.cvalidate.TEXTNUMBER)])),
    });
    this.country = this.form.controls['country'];
    this.state = this.form.controls['state'];
    this.county = this.form.controls['county'];
    this.serviceCompanyName = this.form.controls['serviceCompanyName'];
    this.operatorCompanyName = this.form.controls['operatorCompanyName'];
    this.prospect = this.form.controls['prospect'];
  }

  ngOnDestroy(): void {
    Helper.unsubscribe(this.subscriptions);
  }

  hide(data?: any): void {
    this.dialogRef.close(data);
  }

  onConfirm(): void {
    this.hide(this.wellItems);
  }

  selectedWellsChange(event) {
    if (event && event.selected) {
      this.wellItems = event.selected;
      this.countWells = event.selected.length;
    }
  }

  getCountries() {
    this.subscriptions.push(
      this.historicalWellsService.getCountries().subscribe(
        (res) => {
          this.listContries = res.result;
        }
      )
    );
  }

  getStates() {
    this.subscriptions.push(
      this.historicalWellsService.getStates().subscribe(
        (res) => {
          this.listStates = res.result;
        }
      )
    );
  }

  getCounties() {
    this.subscriptions.push(
      this.historicalWellsService.getCounties().subscribe(
        (res) => {
          this.listConties = res.result;
        }
      )
    );
  }

  getServiceCompanies() {
    this.subscriptions.push(
      this.treatmentService.getListCompanyByType(1).subscribe(
        (res) => {
          this.listServiceCompanies = res.result.items;
        }
      )
    );
  }

  getOperatorCompanies() {
    this.subscriptions.push(
      this.treatmentService.getListCompanyByType(0).subscribe(
        (res) => {
          this.listOperatorCompanies = res.result.items;
        }
      )
    );
  }

  searchWells() {
    if (this.form.valid) {
      this.wellItems = [];
      this.countWells = 0;
      this.wellTable.removeAllSelected();
      this.listSelectWells = this.originListWells;
      this.listSelectWells = this.listSelectWells.filter((item) => {
        const country = item.country ? item.country : '';
        if (this.country.value && country !== this.country.value) {
          return false;
        }
        const state = item.state ? item.state : '';
        if (this.state.value && state !== this.state.value) {
          return false;
        }
        const county = item.county ? item.county : '';
        if (this.county.value && county !== this.county.value) {
          return false;
        }
        const serviceCompanyName = item.serviceCompanyName ? item.serviceCompanyName : '';
        if (this.serviceCompanyName.value && serviceCompanyName !== this.serviceCompanyName.value) {
          return false;
        }
        const operatorCompanyName = item.operatorCompanyName ? item.operatorCompanyName : '';
        if (this.operatorCompanyName.value && operatorCompanyName !== this.operatorCompanyName.value) {
          return false;
        }
        const prospect = item.prospect ? item.prospect : '';
        if (this.prospect.value && prospect.toLowerCase().indexOf(this.prospect.value.toLowerCase()) === -1) {
          return false;
        }
        return true;
      });
    }
  }
}
